import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  LikeRequestDTO,
  LikesQueryKeys,
  LikesResponseDTO,
  ILikeThisRequestDTO,
} from '../types/likes'
import { client, ClientMethodsTypes } from '@/services/v2/client'

const BASE_URL = '/api/v1/likes'
const FIFTEEN_MINUTES = 1000 * 60 * 15

export const useLikes = ({
  surfaceType,
  referencedId,
  page = 0,
}: LikeRequestDTO) => {
  return useQuery({
    queryKey: [LikesQueryKeys.LIKES, surfaceType, referencedId, page],
    queryFn: () =>
      client<LikesResponseDTO>(
        `${BASE_URL}/${surfaceType}/${referencedId}/${page}`
      ),
    enabled: !!referencedId && !!surfaceType,
    cacheTime: FIFTEEN_MINUTES,
  })
}

export const useAddLike = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ surfaceType, referencedId }: ILikeThisRequestDTO) =>
      client(`${BASE_URL}/like-item/${surfaceType}/${referencedId}`, {
        method: ClientMethodsTypes.PATCH,
      }),
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries([
        LikesQueryKeys.LIKES,
        variables.surfaceType,
        variables.referencedId,
      ])
    },
  })
}

export const useRemoveLike = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ surfaceType, referencedId }: ILikeThisRequestDTO) =>
      client(`${BASE_URL}/delete-like-item/${surfaceType}/${referencedId}`, {
        method: ClientMethodsTypes.DELETE,
      }),
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries([
        LikesQueryKeys.LIKES,
        variables.surfaceType,
        variables.referencedId,
      ])
    },
  })
}
